/**
 * Whether the "Push-Geräte" panel (devices of the tenant, broadcast message, neutral lock-screen text,
 * delivery log) is shown in the settings. Hidden for now, not removed: the panel, its server calls and
 * its texts stay as they are, and switching this on lists it again in the sidebar and lets the address
 * `?panel=pushDevices` open it.
 */
export const PUSH_DEVICES_PANEL_VISIBLE = false;
